<template>
  <div
    id="dashboard"
    class="pt-0"
  >
    <v-card>
      <v-card-text>
        <v-container
          v-if="teamFormation.loading"
          class="d-flex justify-center align-center my-16"
          style="height: 400px"
        >
          <v-progress-circular
            indeterminate
            size="100"
          />
        </v-container>
        <v-row
          v-else-if="teamFormation.data"
        >
          <v-col
            lg="9"
            md="12"
            sm="12"
            class="pa-3"
          >
            <v-img
              :src="imgPath"
              contain
              style="height: 80vh"
            >
              <template v-slot:default>
                <v-row
                  class="flex-column"
                  justify="space-between"
                  style="height: 90%"
                >
                  <v-col
                    cols="auto"
                    class="pb-0"
                  >
                    <v-row
                      no-gutters
                      align="center"
                    >
                      <v-col
                        v-if="formations.data.length > 1"
                        cols="auto"
                        class="mr-1"
                      >
                        <v-select
                          v-model="formations.selected"
                          :items="formations.data"
                          :loading="formations.loading || teamFormation.loading"
                          class="ma-1"
                          dense
                          solo
                          hide-details
                          return-object
                          item-text="name"
                          color="white"
                          background-color="white"
                          style="width: 130px"
                        />
                      </v-col>
                      <v-col v-if="formations.data.length > 1 && (!teamFormation.data.team.formation || teamFormation.data.team.formation.id !== formations.selected.id)">
                        <v-btn
                          text
                          small
                          color="black"
                          class="text-none"
                          @click="updateTeam()"
                        >
                          {{ $t("button.set_as_default") }}
                        </v-btn>
                      </v-col>
                      <v-spacer />
                      <v-col cols="auto">
                        <v-progress-circular
                          v-if="formations.submitting"
                          indeterminate
                          color="primary"
                          class="mr-3"
                          size="20"
                        />
                        <span
                          v-else
                          class="mr-3 text--white"
                          style="font-size: 12px"
                        >
                          {{ $t("button.auto_saved") }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-for="(line, index) in reversedLineup"
                    :key="index"
                    class="pb-0"
                    :class="user.sport.name !== 'Football' ? 'd-flex align-center justify-center': ''"
                    :align="user.sport.name === 'Football' ? 'center' : ''"
                  >
                    <v-row
                      justify="space-around"
                      :style="user.sport.name === 'Football' ? {width: `${60 + (40 * (index / (reversedLineup.length - 1)))}%`} : {width: '90%'}"
                    >
                      <v-col
                        v-for="position in line"
                        :key="position.id"
                        cols="auto"
                        class="px-0 pb-1"
                      >
                        <player-lineup-card
                          :players="position.players"
                          :position="position.position"
                          @updateOrder="saveFormation"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col
            lg="3"
            md="12"
            sm="12"
            class="pa-3 fill-height overflow-y-auto"
            style="height: 80vh"
          >
            <div class="mb-4">
              <v-row
                no-gutters
                align="center"
              >
                <v-col>
                  {{ $t("table_title.players") }}
                </v-col>
                <v-col
                  v-if="showAssignedSwitch"
                  cols="auto"
                >
                  <v-switch
                    v-model="showAssignedPlayers"
                    class="mt-0"
                    :label="$t('switch.assigned')"
                    color="primary"
                    hide-details
                  />
                </v-col>
              </v-row>
            </div>

            <div>
              <div v-if="showAssignedPlayers">
                <v-list-item
                  v-for="player_data in assignedPlayers"
                  :key="player_data.player.id"
                  class="mt-1"
                >
                  <v-row>
                    <v-col>
                      <v-list-item-title>{{ player_data.player.first_name[0] }}. {{ player_data.player.last_name }}</v-list-item-title>
                    </v-col>
                    <v-col cols="auto">
                      <v-chip small>
                        {{ player_data.position.short_name }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-list-item>
              </div>
              <div v-else>
                <v-list-item
                  v-for="player in teamFormation.data.unassigned_players"
                  :key="player.id"
                  class="my-1"
                >
                  <v-row
                    align="center"
                    no-gutters
                  >
                    <v-col>
                      <div
                        class="text-body-1"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 90px;"
                      >
                        {{ player.first_name[0] }}. {{ player.last_name }}
                      </div>
                    </v-col>
                    <v-col cols="auto">
                      <v-select
                        :items="availablePostions"
                        item-text="short_name"
                        outlined
                        dense
                        return-object
                        hide-details
                        placeholder="CM"
                        style="max-width: 80px"
                        @input="assignPlayerToPosition(player, $event)"
                      />
                    </v-col>
                  </v-row>
                </v-list-item>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import { FormationApiService } from '@/data/services/FormationApiService'
import PlayerLineupCard from '@/components/lineups/PlayerLineupCard.vue'
import { orderBy } from 'lodash'
import { EventApiService, TeamApiService } from '@/data/services'
import { EventBus } from '@/plugins/bus'
import { EventType } from '@/data/models'
import dayjs from 'dayjs'

import basketball from '@/assets/img/lineups/basketball.png'
import handball from '@/assets/img/lineups/handball.png'
import football from '@/assets/img/lineups/football.png'
import debounce from 'lodash/debounce'

export default {
  name: 'LineupsView',
  components: {
    PlayerLineupCard
  },
  data: () => ({
    players: {
      data: null,
      loading: false
    },
    coaches: {
      data: null,
      loading: false
    },
    formations: {
      data: null,
      loading: false,
      selected: null,
      submitting: false
    },
    matches: {
      data: null,
      loading: false,
      pagination: {
        current_page: 1,
        per_page: 1,
        last_page: 1
      }
    },
    teamFormation: {
      data: null,
      loading: false
    },
    showAssignedPlayers: false,
    showAssignedSwitch: true,
    basketballBackground: basketball,
    footballBackground: football,
    handballBackground: handball
  }),
  computed: {
    selectedTeam() {
      return this.$store.getters[this.$storeGetters.APP_CURRENT_TEAM]
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    reversedLineup() {
      if (!this.teamFormation.data) return

      return [...this.teamFormation.data.lineup].reverse()
    },
    assignedPlayers() {
      return this.teamFormation.data.lineup.flatMap((line) =>
        line.flatMap((item) =>
          item.players.map((player) => {
            return {
              position: item.position,
              player: player.player_data,
              order: player.order
            }
          })
        )
      )
    },
    availablePostions() {
      const positions = []
      this.teamFormation.data.lineup.forEach(line => {
        line.forEach((position) => {
          positions.push(position.position)
        })
      })
      return positions
    },
    imgPath() {
      if (this.user.sport.name === 'Handball') {
        return this.handballBackground
      } else if (this.user.sport.name === 'Basketball') {
        return this.basketballBackground
      } else {
        return this.footballBackground
      }
    }
  },
  watch: {
    'formations.selected': function (value) {
      this.fetchTeamFormation()
    },
    selectedTeam: function (value) {
      this.fetchTeamFormation()
      // disable until better implementation
      // this.fetchMatches()
    },
    'teamFormation.data.unassigned_players': function (value) {
      if (value.length === 0) {
        this.showAssignedPlayers = true
        this.showAssignedSwitch = false
      }
    }
  },
  created() {
    this.fetchFormations()
    // disable until better implementation
    // this.fetchMatches()
  },
  methods: {
    orderBy,
    async fetchFormations() {
      try {
        this.formations.loading = true

        const response = await FormationApiService.getAll()

        this.formations.data = response.data
        this.formations.selected = this.selectedTeam.formation ? this.selectedTeam.formation : this.formations.data[0]
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_data.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.formations.loading = false
        this.fetchTeamFormation()
      }
    },
    async fetchTeamFormation() {
      try {
        this.showAssignedPlayers = false
        this.showAssignedSwitch = true
        this.teamFormation.loading = true

        const response = await FormationApiService.getSpecific(this.formations.selected.id, this.selectedTeam.id, null)

        this.teamFormation.data = response.data
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_data.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.teamFormation.loading = false
      }
    },
    saveFormation: debounce(async function() {
      this.formations.submitting = true

      try {
        await FormationApiService.save({
          team_id: this.selectedTeam.id,
          formation_id: this.formations.selected.id,
          lineup: this.teamFormation.data.lineup
        })
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.formation_submit.error'),
          color: 'error'
        })
      } finally {
        this.formations.submitting = false
      }
    }, 3000),
    async updateTeam() {
      this.submitting = true

      try {
        const data = {
          id: this.selectedTeam.id,
          name: this.selectedTeam.name,
          short_name: this.selectedTeam.shortName,
          formation_id: this.formations.selected.id
        }

        const result = await TeamApiService.update(data)

        EventBus.$emit(this.$events.TEAM_UPDATED, result.data)

        this.$store.dispatch(this.$storeActions.APP_FETCH_TEAMS)

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.team_update.success'),
          color: 'success'
        })
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.team_update.error'),
          color: 'error'
        })
      } finally {
        this.submitting = false
        this.fetchTeamFormation()
      }
    },
    async fetchMatches() {
      try {
        this.matches.loading = true

        const queryParams = {
          from: dayjs().format('YYYY-MM-DD'),
          to: dayjs().add(1, 'month').format('YYYY-MM-DD'),
          team_id: this.selectedTeam.id,
          types: [EventType.MATCH]
        }

        const resp = await EventApiService.getPaginated(queryParams)

        this.matches.data = resp.data
        this.matches.pagination = resp.meta
      } catch (e) {
        this.matches.data = []
      } finally {
        this.matches.loading = false
      }
    },
    assignPlayerToPosition(player, selectedPosition) {
      this.teamFormation.data.lineup.forEach(line => {
        line.forEach((position) => {
          if (position.position === selectedPosition) {
            position.players.push({
              player_data: player,
              order: position.players.length + 1
            })
          }
        })
      })

      const index = this.teamFormation.data.unassigned_players.indexOf(player)
      this.teamFormation.data.unassigned_players.splice(index, 1)
      this.saveFormation()
    }
  }
}
</script>
